import { render, staticRenderFns } from "./DataRecord.vue?vue&type=template&id=82a93a98&"
import script from "./DataRecord.vue?vue&type=script&lang=ts&"
export * from "./DataRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports